var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text"},[_c('h5',[_vm._v(_vm._s(_vm.engine.name)+" ("),_c('currency',{attrs:{"value":_vm.engine.price}}),_vm._v(")")],1),_vm._v(" "),(_vm.engine.description)?_c('p',[_vm._v(_vm._s(_vm.engine.description))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }